"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const getDisplayRoundNumber_1 = __importDefault(require("./getDisplayRoundNumber"));
// 會把 setItems 也 format status
function getFormatBatchItemStatus(item, isSummary = false) {
    if ((item.deletedAt != null && item.deletedAt !== '') || item.cancelled) {
        return '已刪除';
    }
    if (item.cancelled) {
        return '已取消';
    }
    // 組合每一個變價字串
    const modifierDiscounts = [];
    const summaryModifier = [];
    const hasMerchantModifier = item.modifiers.find(modifier => modifier.type === 'MERCHANT' && modifier.deletedAt == null);
    if (item.modifiers != null) {
        item.modifiers.forEach(modifier => {
            if (modifier.deletedAt == null) {
                let discountText = '';
                if (modifier.type !== 'COMBORULE') {
                    if (modifier.name != null) {
                        // 有名字時顯示名字
                        discountText += modifier.name;
                    }
                    if (modifier.amount !== 0) {
                        // 顯示更動金額
                        discountText += (0, getDisplayRoundNumber_1.default)(modifier.amount) + '$';
                    }
                    if (modifier.percent !== 0) {
                        // 顯示更動百分比
                        discountText += String(modifier.percent) + '%';
                    }
                }
                else if (modifier.type === 'COMBORULE' && lodash_1.default.isEmpty(hasMerchantModifier)) {
                    discountText += (0, getDisplayRoundNumber_1.default)(modifier.amount) + '$';
                }
                modifierDiscounts.push(discountText);
                if (modifier.type === 'MERCHANT') {
                    summaryModifier.push(discountText);
                }
            }
        });
    }
    const options = lodash_1.default.map(item.options, option => `${option.name}${option.quantity > 1 ? `x${option.quantity}` : ''}`);
    const tags = lodash_1.default.map(item.tags, 'name');
    const remarks = Array.isArray(item.remarks)
        ? lodash_1.default.filter(item.remarks, remark => !lodash_1.default.isEmpty(remark))
        : item.remarks;
    const status = lodash_1.default.concat(
    // discount,
    options, isSummary ? [] : tags, remarks, isSummary ? summaryModifier : modifierDiscounts);
    return status.join('/');
}
exports.default = getFormatBatchItemStatus;
//# sourceMappingURL=getFormatBatchItemStatus.js.map